<div class="bl-font-color--steel bl-display--flex bl-margin-bottom--8">
  <span [id]="field.id" class="bl-width--50 min-width--50 bl-font-weight--800 bl-margin-right--24 bl-margin-bottom--0">
    {{field.label}}
    <span *ngIf="field.config.subLabel != null" class="bl-font-weight--400 bl-font-color--silver bl-display--block">
      {{field.config.subLabel}}
    </span>
  </span>
  <span *ngIf="field.config.content" class="bl-flex--auto bl-margin-bottom--0 {{formatter}}" 
    [innerHtml]="field.content|safe:'html'">
  </span>

  <span *ngIf="showContent && formatter !== 'block'" class="bl-flex--auto bl-margin-bottom--0 {{formatter}}"
    [attr.aria-labelledby]="field.id">
    {{ field.readableValue | mask:field.config.mask }}
    {{ postfix || '' }}
  </span>
</div>

<p *ngIf="showContent && formatter === 'block'"
  class="bl-flex--auto bl-margin-bottom--24 bl-font-size--18 bl-font-weight--800" [attr.aria-labelledby]="field.id">
  {{ field.readableValue | mask:field.config.mask }}
  {{ postfix || '' }}
</p>